var MagnetismUnit_1;
import { __decorate } from "tslib";
import { Unit } from './Unit';
import { SerializableObject } from '../../data/decorators';
import { UnitPrefix } from './UnitPrefix';
/**
 * @category Unit
 */
let MagnetismUnit = MagnetismUnit_1 = class MagnetismUnit extends Unit {};
MagnetismUnit.TESLA = new MagnetismUnit_1('tesla', {
  baseName: 'magnetism',
  aliases: ['T'],
  prefixes: 'decimal'
});
MagnetismUnit.MICROTESLA = MagnetismUnit_1.TESLA.specifier(UnitPrefix.MICRO);
MagnetismUnit = MagnetismUnit_1 = __decorate([SerializableObject()], MagnetismUnit);
export { MagnetismUnit };